// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%230877BC%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276,9 12,15 18,9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Edit Profile Styles - Compact Professional Layout */

.edit-pic {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    position: relative;
}

.edit-pic img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid #0877BC;
    box-shadow: 0 8px 32px rgba(8, 119, 188, 0.2);
}

.profile_img_icon {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: linear-gradient(135deg, #0877BC, #0A0615);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 2.5rem;
    font-weight: 700;
    border: 4px solid #0877BC;
    box-shadow: 0 8px 32px rgba(8, 119, 188, 0.2);
}

.edit-img-label {
    position: absolute;
    bottom: 0;
    right: 0;
    background: #0877BC;
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 3px solid white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
}

.edit-img-label:hover {
    background: #0A0615;
    transform: scale(1.1);
}

.edit-camera {
    font-size: 16px;
}

.input_addpicsvg {
    display: none;
}

/* Section Headers */
.section-header {
    grid-column: 1 / -1;
    text-align: center;
    margin: 2rem 0 1rem 0;
    padding: 1.5rem;
    background: linear-gradient(135deg, rgba(8, 119, 188, 0.05), rgba(10, 6, 21, 0.05));
    border-radius: 16px;
    border: 1px solid rgba(8, 119, 188, 0.1);
}

.section-header h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #0A0615;
    margin: 0 0 0.5rem 0;
    letter-spacing: 0.5px;
}

.section-header p {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    color: #6c757d;
    margin: 0;
    font-weight: 400;
}

/* Compact Grid Layout */
.input-details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.25rem;
    margin-top: 1.5rem;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
}

.input-detail {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    background: rgba(255, 255, 255, 0.95);
    padding: 1.25rem;
    border-radius: 16px;
    border: 1px solid #e8ecf0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
}

.input-detail:hover {
    box-shadow: 0 4px 16px rgba(8, 119, 188, 0.08);
    border-color: #d1d9e0;
}

.input-detail label {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: #0A0615;
    font-size: 13px;
    letter-spacing: 0.3px;
    margin-bottom: 0.25rem;
    text-transform: uppercase;
}

.input-detail input,
.input-detail select {
    padding: 0.875rem 1rem;
    border: 1.5px solid #e1e5e9;
    border-radius: 10px;
    font-size: 14px;
    font-family: 'Poppins', sans-serif;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
    box-sizing: border-box;
    color: #0A0615;
}

.input-detail input:focus,
.input-detail select:focus {
    outline: none;
    border-color: #0877BC;
    box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
    background: rgba(255, 255, 255, 0.95);
}

.input-detail input::placeholder {
    color: #8b95a1;
    opacity: 0.8;
    font-size: 13px;
}

/* Radio Button Styling */
.input-radio-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.25rem 0;
}

.input-radio-btn input[type="radio"] {
    width: 18px;
    height: 18px;
    accent-color: #0877BC;
    margin: 0;
}

.input-radio-btn label {
    font-size: 14px;
    font-weight: 500;
    color: #0A0615;
    cursor: pointer;
    margin: 0;
    text-transform: none;
}

/* Select Styling */
.input-detail select {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    padding-right: 40px;
}

.input-detail select option {
    color: #0A0615;
    background-color: #ffffff;
    padding: 0.5rem;
    font-size: 14px;
}

.input-detail select option:checked {
    background-color: #0877BC;
    color: white;
}

/* Multi-select styling */
.input-detail select[multiple] {
    min-height: 80px;
    background-image: none;
    padding: 0.75rem;
}

.input-detail select[multiple] option {
    padding: 0.5rem 0.75rem;
    margin: 0.125rem 0;
    border-radius: 6px;
}

.input-detail select[multiple] option:checked {
    background-color: #0877BC;
    color: white;
}

/* Small helper text */
.input-detail small {
    color: #6c757d;
    font-size: 11px;
    margin-top: 0.25rem;
    font-style: italic;
}

/* Validation Error Styling */
.validation_error {
    color: #dc3545;
    font-size: 12px;
    margin-top: 0.25rem;
    font-weight: 500;
    background: rgba(220, 53, 69, 0.1);
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    border-left: 3px solid #dc3545;
}

/* Submit Section */
.submit-section {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    padding: 2rem 0;
}

.submit-button {
    background: linear-gradient(135deg, #0877BC, #0A0615);
    color: white;
    border: none;
    padding: 1.25rem 3rem;
    border-radius: 16px;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 6px 24px rgba(8, 119, 188, 0.3);
    position: relative;
    overflow: hidden;
    min-width: 200px;
}

.submit-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
}

.submit-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 32px rgba(8, 119, 188, 0.4);
}

.submit-button:hover::before {
    left: 100%;
}

.submit-button:active {
    transform: translateY(-1px);
}

.submit-button span {
    position: relative;
    z-index: 1;
}

/* Responsive Design */
@media (max-width: 768px) {
    .input-details {
        grid-template-columns: 1fr;
        gap: 1rem;
        padding: 0 1rem;
    }
    
    .input-detail {
        padding: 1rem;
    }
    
    .edit-pic img,
    .profile_img_icon {
        width: 100px;
        height: 100px;
    }
    
    .profile_img_icon {
        font-size: 2rem;
    }
}

@media (max-width: 480px) {
    .input-details {
        padding: 0 0.5rem;
    }
    
    .input-detail {
        padding: 0.875rem;
    }
    
    .input-detail input,
    .input-detail select {
        padding: 0.75rem 0.875rem;
        font-size: 13px;
    }
}

/* Special styling for focus fields */
.input-detail:has(select[name="primaryFocus"]),
.input-detail:has(select[name="secondaryFocuses"]) {
    background: linear-gradient(135deg, rgba(8, 119, 188, 0.05), rgba(10, 6, 21, 0.05));
    border-color: #0877BC;
    z-index: 1;
    position: relative;
    overflow: visible !important;
    padding-bottom: 0.5rem !important;
}

/* Ensure focus fields are visible */
.input-detail select[name="primaryFocus"],
.input-detail select[name="secondaryFocuses"] {
    z-index: 10 !important;
    position: relative;
    background: rgba(255, 255, 255, 0.95) !important;
    border: 1.5px solid #0877BC !important;
    color: #0A0615 !important;
    opacity: 1 !important;
    visibility: visible !important;
    margin-bottom: 0 !important;
    padding-bottom: 0.875rem !important;
}

.input-detail select[name="primaryFocus"] option,
.input-detail select[name="secondaryFocuses"] option {
    background-color: #ffffff !important;
    color: #0A0615 !important;
    padding: 0.5rem !important;
    opacity: 1 !important;
    visibility: visible !important;
    z-index: 15 !important;
    position: relative !important;
}

/* Selected option: white text on primary blue (visible) */
.input-detail select[name="primaryFocus"] option:checked,
.input-detail select[name="secondaryFocuses"] option:checked {
    background-color: #0877BC !important;
    color: white !important;
}

/* Ensure dropdown options are visible and not clipped */
.input-detail select[name="primaryFocus"] {
    overflow: visible !important;
    z-index: 20 !important;
}

.input-detail select[name="primaryFocus"]:focus {
    z-index: 25 !important;
    position: relative !important;
}

.input-detail select[name="secondaryFocuses"] {
    min-height: 100px !important;
    max-height: 150px !important;
    overflow-y: auto !important;
}

/* Additional fixes for dropdown visibility */
.input-details {
    overflow: visible !important;
}

.input-detail {
    overflow: visible !important;
}

/* Ensure the form container doesn't clip dropdowns */
.edit-profile-container {
    overflow: visible !important;
}

/* Force dropdown to be visible above other elements */
.input-detail select[name="primaryFocus"]:focus,
.input-detail select[name="primaryFocus"]:active {
    z-index: 999 !important;
    position: relative !important;
    transform: translateZ(0) !important;
}

/* Loading state */
.input-detail select:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: #f8f9fa;
}

/* Focus indicators for accessibility */
.input-detail input:focus-visible,
.input-detail select:focus-visible {
    outline: 2px solid #0877BC;
    outline-offset: 2px;
}

/* Animation for form interactions */
@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.input-detail {
    animation: slideInUp 0.3s ease-out;
}

.input-detail:nth-child(odd) {
    animation-delay: 0.1s;
}

.input-detail:nth-child(even) {
    animation-delay: 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/components/Editprofile.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,mFAAmF;IACnF,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,2DAA2D;IAC3D,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,kCAAkC;IAClC,oCAAoC;IACpC,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,SAAS;IACT,oBAAoB;AACxB;;AAEA,mBAAmB;AACnB;IAGI,gBAAgB;IAChB,yDAAwR;IACxR,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,uBAAuB;IACvB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,yBAAyB;IACzB,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;QAC1B,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,yBAAyB;QACzB,eAAe;IACnB;AACJ;;AAEA,qCAAqC;AACrC;;IAEI,mFAAmF;IACnF,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA,oCAAoC;AACpC;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,sCAAsC;IACtC,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;;IAEI,oCAAoC;IACpC,yBAAyB;IACzB,0BAA0B;IAC1B,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA,0DAA0D;AAC1D;;IAEI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA,wDAAwD;AACxD;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA,6CAA6C;AAC7C;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,qDAAqD;AACrD;IACI,4BAA4B;AAChC;;AAEA,sDAAsD;AACtD;;IAEI,uBAAuB;IACvB,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,uCAAuC;AACvC;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/* Edit Profile Styles - Compact Professional Layout */\n\n.edit-pic {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 2rem;\n    position: relative;\n}\n\n.edit-pic img {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 4px solid #0877BC;\n    box-shadow: 0 8px 32px rgba(8, 119, 188, 0.2);\n}\n\n.profile_img_icon {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #0877BC, #0A0615);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 2.5rem;\n    font-weight: 700;\n    border: 4px solid #0877BC;\n    box-shadow: 0 8px 32px rgba(8, 119, 188, 0.2);\n}\n\n.edit-img-label {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background: #0877BC;\n    color: white;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border: 3px solid white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    transition: all 0.3s ease;\n}\n\n.edit-img-label:hover {\n    background: #0A0615;\n    transform: scale(1.1);\n}\n\n.edit-camera {\n    font-size: 16px;\n}\n\n.input_addpicsvg {\n    display: none;\n}\n\n/* Section Headers */\n.section-header {\n    grid-column: 1 / -1;\n    text-align: center;\n    margin: 2rem 0 1rem 0;\n    padding: 1.5rem;\n    background: linear-gradient(135deg, rgba(8, 119, 188, 0.05), rgba(10, 6, 21, 0.05));\n    border-radius: 16px;\n    border: 1px solid rgba(8, 119, 188, 0.1);\n}\n\n.section-header h3 {\n    font-family: 'Poppins', sans-serif;\n    font-size: 20px;\n    font-weight: 700;\n    color: #0A0615;\n    margin: 0 0 0.5rem 0;\n    letter-spacing: 0.5px;\n}\n\n.section-header p {\n    font-family: 'Poppins', sans-serif;\n    font-size: 14px;\n    color: #6c757d;\n    margin: 0;\n    font-weight: 400;\n}\n\n/* Compact Grid Layout */\n.input-details {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1.25rem;\n    margin-top: 1.5rem;\n    max-width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.input-detail {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    background: rgba(255, 255, 255, 0.95);\n    padding: 1.25rem;\n    border-radius: 16px;\n    border: 1px solid #e8ecf0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n}\n\n.input-detail:hover {\n    box-shadow: 0 4px 16px rgba(8, 119, 188, 0.08);\n    border-color: #d1d9e0;\n}\n\n.input-detail label {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    color: #0A0615;\n    font-size: 13px;\n    letter-spacing: 0.3px;\n    margin-bottom: 0.25rem;\n    text-transform: uppercase;\n}\n\n.input-detail input,\n.input-detail select {\n    padding: 0.875rem 1rem;\n    border: 1.5px solid #e1e5e9;\n    border-radius: 10px;\n    font-size: 14px;\n    font-family: 'Poppins', sans-serif;\n    background: rgba(255, 255, 255, 0.9);\n    backdrop-filter: blur(10px);\n    transition: all 0.3s ease;\n    box-sizing: border-box;\n    color: #0A0615;\n}\n\n.input-detail input:focus,\n.input-detail select:focus {\n    outline: none;\n    border-color: #0877BC;\n    box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n    background: rgba(255, 255, 255, 0.95);\n}\n\n.input-detail input::placeholder {\n    color: #8b95a1;\n    opacity: 0.8;\n    font-size: 13px;\n}\n\n/* Radio Button Styling */\n.input-radio-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0.25rem 0;\n}\n\n.input-radio-btn input[type=\"radio\"] {\n    width: 18px;\n    height: 18px;\n    accent-color: #0877BC;\n    margin: 0;\n}\n\n.input-radio-btn label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #0A0615;\n    cursor: pointer;\n    margin: 0;\n    text-transform: none;\n}\n\n/* Select Styling */\n.input-detail select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%230877BC' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 12px center;\n    background-size: 16px;\n    padding-right: 40px;\n}\n\n.input-detail select option {\n    color: #0A0615;\n    background-color: #ffffff;\n    padding: 0.5rem;\n    font-size: 14px;\n}\n\n.input-detail select option:checked {\n    background-color: #0877BC;\n    color: white;\n}\n\n/* Multi-select styling */\n.input-detail select[multiple] {\n    min-height: 80px;\n    background-image: none;\n    padding: 0.75rem;\n}\n\n.input-detail select[multiple] option {\n    padding: 0.5rem 0.75rem;\n    margin: 0.125rem 0;\n    border-radius: 6px;\n}\n\n.input-detail select[multiple] option:checked {\n    background-color: #0877BC;\n    color: white;\n}\n\n/* Small helper text */\n.input-detail small {\n    color: #6c757d;\n    font-size: 11px;\n    margin-top: 0.25rem;\n    font-style: italic;\n}\n\n/* Validation Error Styling */\n.validation_error {\n    color: #dc3545;\n    font-size: 12px;\n    margin-top: 0.25rem;\n    font-weight: 500;\n    background: rgba(220, 53, 69, 0.1);\n    padding: 0.5rem 0.75rem;\n    border-radius: 6px;\n    border-left: 3px solid #dc3545;\n}\n\n/* Submit Section */\n.submit-section {\n    grid-column: 1 / -1;\n    display: flex;\n    justify-content: center;\n    margin-top: 2rem;\n    padding: 2rem 0;\n}\n\n.submit-button {\n    background: linear-gradient(135deg, #0877BC, #0A0615);\n    color: white;\n    border: none;\n    padding: 1.25rem 3rem;\n    border-radius: 16px;\n    font-size: 16px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 6px 24px rgba(8, 119, 188, 0.3);\n    position: relative;\n    overflow: hidden;\n    min-width: 200px;\n}\n\n.submit-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    transition: left 0.5s;\n}\n\n.submit-button:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 8px 32px rgba(8, 119, 188, 0.4);\n}\n\n.submit-button:hover::before {\n    left: 100%;\n}\n\n.submit-button:active {\n    transform: translateY(-1px);\n}\n\n.submit-button span {\n    position: relative;\n    z-index: 1;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .input-details {\n        grid-template-columns: 1fr;\n        gap: 1rem;\n        padding: 0 1rem;\n    }\n    \n    .input-detail {\n        padding: 1rem;\n    }\n    \n    .edit-pic img,\n    .profile_img_icon {\n        width: 100px;\n        height: 100px;\n    }\n    \n    .profile_img_icon {\n        font-size: 2rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .input-details {\n        padding: 0 0.5rem;\n    }\n    \n    .input-detail {\n        padding: 0.875rem;\n    }\n    \n    .input-detail input,\n    .input-detail select {\n        padding: 0.75rem 0.875rem;\n        font-size: 13px;\n    }\n}\n\n/* Special styling for focus fields */\n.input-detail:has(select[name=\"primaryFocus\"]),\n.input-detail:has(select[name=\"secondaryFocuses\"]) {\n    background: linear-gradient(135deg, rgba(8, 119, 188, 0.05), rgba(10, 6, 21, 0.05));\n    border-color: #0877BC;\n    z-index: 1;\n    position: relative;\n    overflow: visible !important;\n    padding-bottom: 0.5rem !important;\n}\n\n/* Ensure focus fields are visible */\n.input-detail select[name=\"primaryFocus\"],\n.input-detail select[name=\"secondaryFocuses\"] {\n    z-index: 10 !important;\n    position: relative;\n    background: rgba(255, 255, 255, 0.95) !important;\n    border: 1.5px solid #0877BC !important;\n    color: #0A0615 !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    margin-bottom: 0 !important;\n    padding-bottom: 0.875rem !important;\n}\n\n.input-detail select[name=\"primaryFocus\"] option,\n.input-detail select[name=\"secondaryFocuses\"] option {\n    background-color: #ffffff !important;\n    color: #0A0615 !important;\n    padding: 0.5rem !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    z-index: 15 !important;\n    position: relative !important;\n}\n\n/* Selected option: white text on primary blue (visible) */\n.input-detail select[name=\"primaryFocus\"] option:checked,\n.input-detail select[name=\"secondaryFocuses\"] option:checked {\n    background-color: #0877BC !important;\n    color: white !important;\n}\n\n/* Ensure dropdown options are visible and not clipped */\n.input-detail select[name=\"primaryFocus\"] {\n    overflow: visible !important;\n    z-index: 20 !important;\n}\n\n.input-detail select[name=\"primaryFocus\"]:focus {\n    z-index: 25 !important;\n    position: relative !important;\n}\n\n.input-detail select[name=\"secondaryFocuses\"] {\n    min-height: 100px !important;\n    max-height: 150px !important;\n    overflow-y: auto !important;\n}\n\n/* Additional fixes for dropdown visibility */\n.input-details {\n    overflow: visible !important;\n}\n\n.input-detail {\n    overflow: visible !important;\n}\n\n/* Ensure the form container doesn't clip dropdowns */\n.edit-profile-container {\n    overflow: visible !important;\n}\n\n/* Force dropdown to be visible above other elements */\n.input-detail select[name=\"primaryFocus\"]:focus,\n.input-detail select[name=\"primaryFocus\"]:active {\n    z-index: 999 !important;\n    position: relative !important;\n    transform: translateZ(0) !important;\n}\n\n/* Loading state */\n.input-detail select:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    background-color: #f8f9fa;\n}\n\n/* Focus indicators for accessibility */\n.input-detail input:focus-visible,\n.input-detail select:focus-visible {\n    outline: 2px solid #0877BC;\n    outline-offset: 2px;\n}\n\n/* Animation for form interactions */\n@keyframes slideInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.input-detail {\n    animation: slideInUp 0.3s ease-out;\n}\n\n.input-detail:nth-child(odd) {\n    animation-delay: 0.1s;\n}\n\n.input-detail:nth-child(even) {\n    animation-delay: 0.2s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
